// extracted by mini-css-extract-plugin
module.exports = {"button":"_2bpkCiH1sRyw","button_small":"_3MeeqFjV0tbr"};